import View from "constants/view";

export const STATIC_ROUTES = [View.SettingsTextLocalisations, View.SettingsForms];
